export function compute(fn) {
    return fn();
}
//# sourceMappingURL=misc.js.map